// 自定义组件
import Content from "./Content";
import Search from "./Search";
//主页样式公共模版
import HomeCommon from "./HomeCommon";
//主页兼容移动端模版
import SearDraw from "./SearDraw";
//主页检索框
import TableCell from "./tableCell";
import Tree from "./tree";
//学生体检部分项目选择
import EditTabPanel from "../preScreening/task/EditTabPanel.vue"
// 自动全局加载
export default Vue => {
  const components = {
    Content,
    Search,
    HomeCommon,
    SearDraw,
    TableCell,
    Tree,
    EditTabPanel
  };
  for (const key of Object.keys(components)) {
    Vue.component(key, components[key]);
  }
};
